import { format } from "date-fns";

import type { BudgetRule, BudgetRuleKind } from "@/schemas";

import type { GroupedCategory } from "../types";

export function monthToString(value: Date): string {
  return format(new Date(value.getFullYear(), value.getMonth(), 1), "yyyy-MM");
}

export function sanitizeKey(value: string): string {
  return (
    value
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "") || "item"
  );
}

export function categoryLabel(value: string): string {
  return value.trim() || "Uncategorized";
}

export function groupRulesByKind(
  rules: BudgetRule[],
  kind: BudgetRuleKind,
): GroupedCategory[] {
  const grouped = new Map<string, BudgetRule[]>();

  rules
    .filter((rule) => rule.kind === kind)
    .forEach((rule) => {
      const key = categoryLabel(rule.category);
      grouped.set(key, [...(grouped.get(key) || []), rule]);
    });

  return Array.from(grouped.entries())
    .map(([name, categoryRules]) => ({
      name,
      total: categoryRules
        .filter((rule) => rule.enabled)
        .reduce((sum, rule) => sum + rule.amount, 0),
      rules: categoryRules.sort((left, right) =>
        left.label.localeCompare(right.label),
      ),
    }))
    .sort((left, right) => left.name.localeCompare(right.name));
}
